module.exports = "/_next/static/images/OgImage-16e5b67c5553c3b0341cc9c8d539a72e.png";